import { EditFieldBase } from './edit-field-base.model';
import { EditFieldControlTypeEnum } from './edit-field-control-type.enum.model';

export class EditFieldTextbox extends EditFieldBase<string> {
    controlType = EditFieldControlTypeEnum.Textbox;
}
